import {RouteRecordRaw} from "vue-router";
import UserLayout from "@/components/layout/UserLayout.vue";
import OrderPage from '@/views/OrderView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import PersonPage from '@/views/PersonView.vue';
import MemberView from '@/views/MemberView.vue';
import NoAuthPage from '@/views/NoAuthView.vue';
import VideoView from '@/views/VideoView.vue';
import InterviewView from '@/views/InterviewHomeView.vue';
import InterviewQuestionList from '@/views/InterviewQuestionList.vue';
import InterviewQuestionDetail from '@/views/InterviewQuestionDetail.vue';
import ACCESS_ENUM from "@/access/ACCESS_ENUM";
import HomePage from "@/views/HomeView.vue";
import ProjectPage from "@/views/ProjectView.vue";
import {
    AccountBookOutlined,
    BookOutlined,
    BulbOutlined,
    CloudOutlined,
    FolderOutlined,
    HomeOutlined,
    PlaySquareOutlined,
    SmileOutlined,
    UserOutlined
} from '@ant-design/icons-vue';

import ProjectDetail from "@/components/project/ProjectDetail.vue";
import CourseDetail from "@/components/courseDegin/CourseDetail.vue";
import ArticleDetail from "@/components/article/ArticleDetail.vue";
import VideoDetail from "@/components/video/VideoDetail.vue";
import StudyMaterialPage from "@/views/StudyMaterialView.vue";
import StudyMaterialDetail from "@/views/StudyMaterialDetail.vue";

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/user',
        name: "用户",
        component: UserLayout,
        meta: {
            visible: true,
        },
        children: [
            // {
            //     path: '/user/login',
            //     name: "用户登录",
            //     component: UserLoginPage,
            // },
            // {
            //     path: '/user/register',
            //     name: "用户注册",
            //     component: UserRegisterPage,
            // },
        ]
    },
    {
        path: '/',
        name: "首页",
        component: HomePage,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: HomeOutlined
        }
    },
    {
        path: '/article/detail/22',
        name: "牛站介绍",
        component: ArticleDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: CloudOutlined
        },
    },
    {
        path: '/business/project',
        name: "项目源码",
        component: ProjectPage,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: FolderOutlined
        },
    },

    {
        path: '/business/video',
        name: "视频教学",
        component: VideoView,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: PlaySquareOutlined
        },
    },
    {
        path: '/business/interview',
        name: "面试题解",
        component: InterviewView,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: BulbOutlined
        },
    },
    {
        path: '/business/studyMaterial',
        name: "学习资料",
        component: StudyMaterialPage,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: BookOutlined
        },
    },
    {
        path: '/order',
        name: '我的订单',
        component: OrderPage,
        meta: {
            access: ACCESS_ENUM.USER,
            icon: AccountBookOutlined
        }
    },
    {
        path: '/person',
        name: '个人中心',
        component: PersonPage,
        meta: {
            access: ACCESS_ENUM.USER,
            icon: UserOutlined
        }
    },
    {
        path: '/member',
        name: '会员充值',
        component: MemberView,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            icon: SmileOutlined
        }
    },

    {
        path: '/noAuth',
        name: '没登陆',
        component: NoAuthPage,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },


    {
        path: '/business/project/detail/:id',
        name: '项目详情',
        component: ProjectDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },

    {
        path: '/business/courseDesign/detail/:id',
        name: '产品详情',
        component: CourseDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },

    {
        path: '/business/studyMaterial/detail/:id',
        name: '学习资料详情',
        component: StudyMaterialDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },


    {
        path: '/article/detail/:id',
        name: '文章详情',
        component: ArticleDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },


    {
        path: '/video/detail/:id',
        name: '视频详情',
        component: VideoDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },


    {
        path: '/business/interview/detail/:id/:name',
        name: '题目列表',
        component: InterviewQuestionList,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },

    {
        path: '/business/interview/question/:profileId/:profileName/:id',
        name: '题目详情',
        component: InterviewQuestionDetail,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },

    //404的页面处理
    {
        path: '/notfound',
        name: '404',
        component: NotFoundView,
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },

    {
        path: '/:pathMatch(.*)',
        redirect: '/notfound',
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },

    /**
     * gitee的回调地址处理
     */
    {
        path: '/callback',
        component: () => import('@/components/gitee/loginByGitee.vue'),
        meta: {
            access: ACCESS_ENUM.NOT_LOGIN,
            visible: true,
        }
    },


];
